import options from './humidity.component';


export default {
    selector: "dtEmulatorHumidity",
    options
}